import { AfterViewInit, Component, ElementRef, Inject, NgZone, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/network/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { GoogleDriveService } from './google-drive.service';
import { NotificationService } from 'src/app/shared/notificaton.service';
import { DOCUMENT } from '@angular/common';
import { GoogleSettingsService } from './google-settings.service';

@Component({
    templateUrl: './reupload-file.component.html',
    styleUrls: ['../general.scss', './upload-file.component.scss']
})
export class ReuploadFileComponent implements OnInit, AfterViewInit {
    private googleDriveService: GoogleDriveService;
    fileToUpload: File = null;
    filename: string = '';
    projectId: string;

    constructor(private dataService: DataService, private router: Router, private activatedRoute: ActivatedRoute, private ngZone: NgZone,
        private projectService: ProjectService, private importProgressService: ImportProgressService, notifier: NotificationService,
        @Inject(DOCUMENT) private document, private elementRef: ElementRef, googleSettingsService: GoogleSettingsService) {
        this.googleDriveService = new GoogleDriveService(notifier, this.filePickedCallback.bind(this), document, elementRef, googleSettingsService);
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if (projectId) {
                this.projectId = projectId;
                this.projectService.getOriginalFileName(projectId).then(originalFilename =>{
                    this.filename = originalFilename;
                });
            }
        });
    }

    ngAfterViewInit(): void {
        this.googleDriveService.addScriptInclude();
    }

    handleFileInput(files: FileList) {
        if(files.length > 0) {
            this.fileToUpload = files.item(0);
            this.filename = files.item(0).name;
        }
    }

    async uploadFile() {
        if(!this.fileToUpload) {
            return;
        }
        await this.dataService.postFile('reupload', this.fileToUpload, { projectId:this.projectId });
        this.importProgressService.setImportStep(ImportStep.controlColumn);
        this.router.navigateByUrl('/data-sanity?projectId=' + this.projectId);
    }
    
    pickAndDownloadFile() {
        this.googleDriveService.pickAndDownloadFile();
    }

    private filePickedCallback(fileId, accessToken, fileName, mimeType) {
        let self = this;
        this.dataService.post('upload/reuploadFromPrivateGoogleDoc?projectId=' + this.projectId, {
            fileId: fileId,
            accessToken: accessToken,
            fileName: fileName,
            mimeType: mimeType,
        }).then(projectId => {
            self.importProgressService.setImportStep(ImportStep.upload);
            self.ngZone.run(() => {
                self.router.navigateByUrl('/data-sanity?projectId=' + this.projectId);
            });
        });
    }
}
